export default "__VITE_ASSET__B4BWDX_w__"